<template>
  <div style="height: 100%;width: 100%;border-radius: 10px"></div>
</template>

<script>
  import Highcharts from 'highcharts'
  import { randomIntegerInRange } from '../../../utils/tools'
  export default {
    name: 'ColumnChart',
    props: {
      data: {
        type: Array
      }
    },
    data() {
      return {
        chart: null
      }
    },
    watch: {
      data() {
        if(this.chart) {
          this.updateChart()
        }
      },
      chart() {
        this.updateChart()
      }
    },
    computed: {
      width() {
        return this.$el.clientWidth
      },
      height() {
        return this.$el.clientHeight
      },
      incomeTotal() {
        return this.data.map(item => {
          return {
            y: item.total,
            name: item.day
          }
        })
      },
      income() {
        return this.data.map(item => {
          return {
            y: item.income,
            name: item.day
          }
        })
      }
    },
    methods: {
      updateChart() {
        this.chart.update({
          xAxis: {
            labels: {
              step: this.incomeTotal.length > 7 ? 4 : 1
            },
          },
          // series: [
          //   {
          //     data: this.incomeTotal,
          //     name:'收益笔数（单）',
          //     color: '#2B90D9'
          //   },
          //   {
          //     data:this.income,
          //     name:'收益（元）',
          //     color: '#FC6853'
          //   }
          // ]
        })
        this.chart.series[0].setData(this.incomeTotal)
        this.chart.series[1].setData(this.income)
      }
    },
    mounted() {
      const _this = this
      this.chart = Highcharts.chart(this.$el, {
        chart: {
          type: 'column',
          width: this.width,
          height: this.height
        },
        title: {
          align: 'left',
          text: '收益',
          style: {
            'fontWeight': 'bold'
          }
        },
        legend: {
          padding: 3,
          useHTML: true,
          itemStyle: {
            lineHeight: '21px'
          },
          symbolPadding: 5,
          squareSymbol: false,
          symbolHeight: 4,
          symbolWidth: 16,
          symbolRadius: 0
        },
        xAxis: {
          title: {
            text: null
          },
          type: "category",
          tickAmount: 10
        },
        yAxis: {

          title: {
            text: null
          },
        },
        credits: {
          enabled: false
        },
        tooltip: {
          shared: true
        },
        series: [
          {
            negativeColor: '#00ce9b',
            data: [],
            name:'收益笔数（单）',
            color: '#2B90D9'
          },
          {
            negativeColor: '#00ce9b',
            data: [],
            name:'收益（元）',
            color: '#FC6853'
          }
        ]
      })
    }
  }
</script>

<style scoped>

</style>